import { isNot } from 'typescript-styled-is'
import styled from '../../../theme'
import isLink from '../../../theme/styles/isLink'

const MobileButtonLink = styled.a<ILinkProps>`
   ${isLink};
  width: 100%;
  color: black;
  text-decoration: none;
  cursor: pointer;

  ${isNot('nested')`
    padding: 0 ${({ size }) => (size ? 1.25 * size : 1.25)}em 0 ${({ size }) =>
  size ? size : 1}em;
  `}
`

export default MobileButtonLink


export interface ILinkProps {
  nested?: boolean
  size?: number
  exact?: boolean
}
